// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_headerControl__k-fT\\+ {
  display: flex !important;
  align-items: center;
  justify-content: flex-end;
  background-color: var(--sidenav-bg);
}

.Header_logoutLink__U4BZd {
  display: flex;
  align-items: center;
  gap: 6px;
}

.Header_sidebarTogglerPC__T\\+Xu1 {
  display: block !important;
}

.Header_sidebarTogglerMobile__DiULC {
  display: none !important;
}

.Header_trigger__sNojN {
  padding: 0;
  font-size: 18px;
  line-height: 64px;
  cursor: pointer;
  transition: color 0.3s;
}

.Header_logo__foonx {
  height: 32px;
  margin: 16px;
  background: rgba(255, 255, 255, 0.3);
}

@media (max-width: 575.98px) {
}

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
  .Header_sidebarTogglerPC__T\\+Xu1 {
    display: none !important;
  }

  .Header_sidebarTogglerMobile__DiULC {
    display: block !important;
  }
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
}

/* Large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/layouts/Header.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;AACtC;;AAEA;AACA;;AAEA,sDAAsD;AACtD;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,8CAA8C;AAC9C;AACA;;AAEA,+CAA+C;AAC/C;AACA","sourcesContent":[".headerControl {\n  display: flex !important;\n  align-items: center;\n  justify-content: flex-end;\n  background-color: var(--sidenav-bg);\n}\n\n.logoutLink {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.sidebarTogglerPC {\n  display: block !important;\n}\n\n.sidebarTogglerMobile {\n  display: none !important;\n}\n\n.trigger {\n  padding: 0;\n  font-size: 18px;\n  line-height: 64px;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n\n.logo {\n  height: 32px;\n  margin: 16px;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n@media (max-width: 575.98px) {\n}\n\n/* Small devices (landscape phones, less than 768px) */\n@media (max-width: 767.98px) {\n  .sidebarTogglerPC {\n    display: none !important;\n  }\n\n  .sidebarTogglerMobile {\n    display: block !important;\n  }\n}\n\n/* Medium devices (tablets, less than 992px) */\n@media (max-width: 991.98px) {\n}\n\n/* Large devices (desktops, less than 1200px) */\n@media (max-width: 1199.98px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerControl": `Header_headerControl__k-fT+`,
	"logoutLink": `Header_logoutLink__U4BZd`,
	"sidebarTogglerPC": `Header_sidebarTogglerPC__T+Xu1`,
	"sidebarTogglerMobile": `Header_sidebarTogglerMobile__DiULC`,
	"trigger": `Header_trigger__sNojN`,
	"logo": `Header_logo__foonx`
};
export default ___CSS_LOADER_EXPORT___;
